<template>
  <div>
    <component-header
      title="Raise Ticket"
      :hasReload="true"
      @reload-data="reloadData"
      :hasSearch="false"
      :hasback="true"
      @back-press="$router.go(-1)"
      :hasCreate="true"
      @create-press="$router.push({ name: 'CreateRequest', params:{listData: $route.params.customerData} })"
      createButtonText="Create Request"
      :hasRequestList="true"
      @request-list-press="
        $router.push({ name: 'MyList', params: { id: $route.params.id, listData: $route.params.customerData } })
      "
      requestListButtonText="Request List"
    />
    <b-card>
      <div class="d-flex dashboard justify-content-center">
        <!-- Raised Box -->
        <b-card class="box text-white bg-orange2 text-center">
          <span class="img1"></span>
          <img src="../../../public/img/png/Group.png" alt="" />
          <h1 class="mb-0">Raised</h1>
          <h2>05</h2>
        </b-card>

        <!-- Solved Box -->
        <b-card class="box text-white bg-blue text-center">
          <span class="img2"></span>
          <img src="../../../public/img/png/Group 1000002577.png" alt="" />
          <h1 class="mb-0">Solved</h1>
          <h2>15</h2>
        </b-card>

        <!-- Pending Box -->
        <b-card class="box text-white bg-green text-center">
          <span class="img3"></span>
          <img src="../../../public/img/png/Vector.png" alt="" />
          <h1 class="mb-0">Pending</h1>
          <h2>02</h2>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";

export default {
  components: {
    ComponentHeader,
  },
  data() {
    return {};
  },
  methods: {
    reloadData() {},
  },
  mounted() {
    // this.reloadData();
    const data = this.$route.params.data;   
    const listData = this.$route.params.customerData   
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.box {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin: 10px;
}

.bg-orange2 {
  background-color: #ff8f61;
}

.bg-blue {
  background-color: #1abfff;
}

.bg-green {
  background-color: #96da45;
}

h2 {
  font-size: 48px;
  font-weight: bold;
  color: white;
  margin: 0;
  position: absolute;
  bottom: 20px;
  left: 15px;
}

h1 {
  color: white;
  font-size: 18px;
  position: absolute;
  top: 15px;
  left: 15px;
  margin: 0;
}

img {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  z-index: 2;
  transition: transform 0.3s;
}

img:hover {
  transform: scale(1.1);
}

/* Background circles for images */
.img1,
.img2,
.img3 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
}

.img1 {
  background-color: #ffa47e;
}

.img2 {
  background-color: #53ceff;
}

.img3 {
  background-color: #aae95f;
}

@media (max-width: 768px) {
  .box {
    width: 150px;
    height: 150px;
  }
  h2 {
    font-size: 36px;
  }
  h1 {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .box {
    width: 120px;
    height: 120px;
  }
  h2 {
    font-size: 28px;
  }
  h1 {
    font-size: 14px;
  }
  img {
    width: 25px;
    height: 25px;
  }
}
</style>
